import { useRecoilValue } from 'recoil';
import { fileUploadSettingsSelector, type FileUploadSettings } from '@/state/uiSettings';

/**
 * Hook to access file upload settings from global UI settings state.
 * Returns default settings if UI settings are not available.
 */
export const useFileUploadSettings = (): FileUploadSettings => {
  return useRecoilValue(fileUploadSettingsSelector);
};